// Combat intent builders for the server-authoritative combat pipeline. Each
// returns a `{ domain:'combat', kind, ... }` object the server's `match:intent`
// handler routes into `runCombatIntentForMatch` (combatService). Payload shapes
// mirror the server engine's dispatch exactly. Keep them in lockstep with
// valkenhall-server/src/match/combatService.js.

// Ranged shot: attacker fires at a target, resolves with no defend window.
export function shotIntent(attackerId, target) {
  return { domain: 'combat', kind: 'shot', attackerId, target };
}

// Declare a melee attack. `fromCell` is the attacker's origin cell (or null).
export function declareIntent(attackerId, target, fromCell = null) {
  return { domain: 'combat', kind: 'declare', attackerId, target, fromCell };
}

// Commit the defender set. `defenders` are the added defender ids; `removeTarget`
// withdraws the originally-attacked unit (honored only when others joined).
export function defendIntent(defenders = [], removeTarget = false) {
  return { domain: 'combat', kind: 'defend', defenders, removeTarget };
}

// Split the attacker's power across multiple defenders. `assignment` is an array
// of [defenderId, amount] pairs (the server rebuilds a Map from it).
export function assignIntent(assignment = []) {
  return { domain: 'combat', kind: 'assign', assignment };
}

// Offer an intercept window for a move-without-attack. `candidates` are the
// eligible interceptor ids at `cell`.
export function offerInterceptIntent(moverId, cell, candidates = []) {
  return { domain: 'combat', kind: 'offer-intercept', moverId, cell, candidates };
}

// Pick interceptors (or none → declines the intercept server-side).
export function interceptIntent(interceptors = []) {
  return { domain: 'combat', kind: 'intercept', interceptors };
}
